<template>
  <div v-if="Object.keys(errorsToShow).length > 0" id="form-root-errors" class="rounded-md bg-red-50 p-4" data-testid="form-root-errors">
    <div class="flex items-start">
      <div class="flex text-red-400">
        <svgicon name="circle-x" fill />
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-red-800">Fejl</h3>
        <div class="mt-2 text-sm text-red-700">
          <ul class="list-disc space-y-1 pl-5">
            <li v-for="(error, label) in errorsToShow" :key="label + error.join(',')">
              <span class="font-medium">{{ label }}</span>
              {{ error.join(", ") }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseFormRootErrors",

  inject: ["rootErrors"],

  props: {
    errors: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  computed: {
    errorsToShow() {
      const errorsToShow = Object.assign({}, this.rootErrors, this.errors);
      delete errorsToShow.__humanNames;
      return errorsToShow;
    },
  },
};
</script>
